import './terms.scss';
export default class LegalTermsController {
    /* @ngInject */
    constructor() {

    }
}